import React from "react";
import AccountDeletion from "./AccountDeletion";
import top from "../../assets/mth/top.webp";
import gear from "../../assets/mth/gear.webp";
import deleteImage from "../../assets/mth/delete.webp";

function Merge2AccountDeletion() {
  return (
    <AccountDeletion
      gameName="Merge Treasure Hunt"
      images={{ top, gear, delete: deleteImage }}
    />
  );
}

export default Merge2AccountDeletion;
